module.exports = __webpack_public_path__ + "static/media/successIcon.1aa1b8d0.svg";